module.exports = __webpack_public_path__ + "static/media/discord.7f1a4a7f.png";